import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Button } from '@/components/ui/button';
import { ArrowUpDown, ArrowUp, ArrowDown } from 'lucide-react';

export type SortField = 'date' | 'clarity' | 'phase' | 'title';
export type SortDirection = 'asc' | 'desc';

export interface SortOptions {
  field: SortField;
  direction: SortDirection;
}

interface SessionSortProps {
  sortOptions: SortOptions;
  onSortChange: (options: SortOptions) => void;
}

const SORT_OPTIONS = [
  { value: 'date', label: 'Datum' },
  { value: 'clarity', label: 'Clarity Score' },
  { value: 'phase', label: 'Phase' },
  { value: 'title', label: 'Alphabetisch' },
];

export const SessionSort = ({ sortOptions, onSortChange }: SessionSortProps) => {
  const toggleDirection = () => {
    onSortChange({
      ...sortOptions,
      direction: sortOptions.direction === 'asc' ? 'desc' : 'asc',
    });
  };

  const handleFieldChange = (value: string) => {
    onSortChange({
      ...sortOptions,
      field: value as SortField,
    });
  };

  const SortIcon = sortOptions.direction === 'asc' ? ArrowUp : ArrowDown;

  return (
    <div className="flex items-center gap-1">
      <Select value={sortOptions.field} onValueChange={handleFieldChange}>
        <SelectTrigger className="w-[100px] sm:w-[130px] h-8 rounded-lg border-border/50 bg-muted/30 hover:border-primary/30 transition-all text-xs">
          <div className="flex items-center gap-1.5">
            <ArrowUpDown className="h-3 w-3 text-muted-foreground" />
            <SelectValue />
          </div>
        </SelectTrigger>
        <SelectContent className="rounded-lg border-border/50">
          {SORT_OPTIONS.map((option) => (
            <SelectItem key={option.value} value={option.value} className="rounded-lg text-xs">
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      <Button
        variant="ghost"
        size="icon"
        onClick={toggleDirection}
        className="h-8 w-8 hover:bg-primary/5 hover:text-primary transition-all"
        aria-label={sortOptions.direction === 'asc' ? 'Aufsteigend sortieren' : 'Absteigend sortieren'}
      >
        <SortIcon className="h-3.5 w-3.5" />
      </Button>
    </div>
  );
};
